import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { EmptyState } from "../../../../components/primitives/feedback/EmptyState";
import { LoadingState } from "../../../../components/primitives/feedback/LoadingState";
import { RequireRole } from "../../../../components/gate/RequireRole";
import { FeedGrid } from "../../../../components/domain/data-display/FeedGrid";
import { SearchBar } from "../../../../components/primitives/inputs/SearchBar";
import { LibraryPage } from "../LibraryPage";
import { useFeedList } from "./useFeedList";
import { ROUTES, feedPath } from "../../../../route_paths";

/** The Library's feeds: the standing PubMed queries that keep the corpus up to date. */
export default function Feeds() {
  const { list, statistics, query, setQuery } = useFeedList();

  return (
    <LibraryPage
      actions={
        <RequireRole role="platform.admin">
          <Button
            component={Link}
            to={ROUTES.internal.library.feeds.new.path()}
            variant="contained"
            startIcon={<AddIcon />}
          >
            New feed
          </Button>
        </RequireRole>
      }
    >
      <SearchBar
        value={query}
        onChange={setQuery}
        placeholder="Search feed name or description…"
        ariaLabel="Search feeds"
      />
      {list.loading ? (
        <LoadingState />
      ) : list.items.length === 0 && list.error ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={list.refresh}>
              Try again
            </Button>
          }
        >
          {list.error}
        </Alert>
      ) : list.items.length === 0 && query.trim() ? (
        <EmptyState
          title="No feeds match"
          message={`No feed's name or description holds "${query.trim()}".`}
        />
      ) : list.items.length === 0 ? (
        <EmptyState
          title="No feeds yet"
          message="A feed runs a PubMed query every week and brings in only what's new."
        />
      ) : (
        <FeedGrid
          feeds={list.items}
          statistics={statistics}
          getFeedHref={feedPath}
          scroll={list.scroll}
        />
      )}
    </LibraryPage>
  );
}
